// extracted by mini-css-extract-plugin
export default {"overlay":"MenuDrawer_overlay__1Dwzh","menu":"MenuDrawer_menu__+NgQd","show":"MenuDrawer_show__JrYQB","fadeIn":"MenuDrawer_fadeIn__6LSx1","content":"MenuDrawer_content__IvArZ"};